@if (doctor) {
    <div class="logged-in-view space-y-8">
        <!-- Header Section -->
        <div class="space-y-1">
            <h1 class="text-app-primary-10">
                Guten Tag, {{doctor.title ? doctor.title + ' ' : ''}}{{doctor.firstName}} {{doctor.lastName}}
            </h1>
            <p class="text-app-primary-10/70 text-lg mt-3">
                Willkommen in Ihrem persönlichen Bereich.
            </p>
        </div>

        <!-- Terminübersicht Section -->
        <div class="bg-white rounded-button shadow-sm border border-app-primary-10 p-6 space-y-6 w-full">
            <div class="text-xl font-bold text-app-primary-10">Terminübersicht</div>

            <!-- Heute -->
            <div class="space-y-3">
                <div class="text-sm font-semibold text-gray-500 uppercase tracking-wider">Heute</div>
                <div class="space-y-2">
                    @for (appointment of todayAppointments; track appointment.id) {
                        <div (click)="toPatientFile(appointment)"
                             class="flex items-center justify-between p-4 bg-app-background-20 rounded-lg border border-app-primary-10/5 hover:border-app-primary-10/20 cursor-pointer transition-colors">
                            <div class="flex flex-col">
                                <span class="font-semibold text-app-primary-10">{{appointment.from | date: 'dd.MM.yyyy - HH:mm'}} Uhr</span>
                                <div class="flex items-center gap-2 mt-1">
                                    <div class="w-6 h-6 rounded-md bg-app-primary-10/10 flex items-center justify-center">
                                        <i class="fa-regular fa-clipboard text-[10px] text-app-primary-10"></i>
                                    </div>
                                    <span class="text-sm text-app-secondary-10">{{appointment.patient.firstName}} {{appointment.patient.lastName}}</span>
                                </div>
                            </div>
                        </div>
                    } @empty {
                        <div class="p-4 bg-gray-50 rounded-lg text-center text-gray-400 text-sm">
                            Keine Termine für heute geplant
                        </div>
                    }
                </div>
            </div>

            <!-- Diese Woche -->
            <div class="space-y-3">
                <div class="text-sm font-semibold text-gray-500 uppercase tracking-wider">Diese Woche</div>
                <div class="space-y-2">
                    @for (appointment of thisWeekAppointments; track appointment.id) {
                        <div (click)="toPatientFile(appointment)"
                             class="flex items-center justify-between p-4 bg-gray-100/50 rounded-lg border border-transparent hover:border-app-primary-10/20 cursor-pointer transition-colors">
                            <div class="flex flex-col">
                                <span class="font-semibold text-gray-600">{{appointment.from | date: 'dd.MM.yyyy - HH:mm'}} Uhr</span>
                                <span class="text-sm text-gray-500">{{appointment.patient.firstName}} {{appointment.patient.lastName}}</span>
                            </div>
                        </div>
                    } @empty {
                        <div class="p-4 bg-gray-50 rounded-lg text-center text-gray-400 text-sm">
                            Keine weiteren Termine für diese Woche
                        </div>
                    }
                </div>
            </div>

            <div class="flex justify-center pt-2">
                <button routerLink="/termin-administration" class="btn tertiary-button border-app-primary-10/20">
                    Alle Termine ansehen
                </button>
            </div>
        </div>

        <!-- Bottom Cards Section -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            <!-- Opening Hours Card -->
            <div class="bg-white rounded-button shadow-sm border border-app-primary-10 p-6 space-y-4">
                <div class="flex flex-col lg:flex-row items-center justify-between border-b border-gray-50 pb-4 gap-2">
                    <div class="text-xl font-bold text-app-primary-10">Aktuelle Öffnungszeiten</div>
                    <button class="btn tertiary-button" routerLink="/administration">Öffnungszeiten anpassen</button>
                </div>

                <div class="space-y-3">
                    @for (day of daysOfWeek; track day.key) {
                        <div class="flex justify-between items-start text-sm py-1">
                            <span class="text-app-primary-10 font-medium">{{day.label}}:</span>
                            <div class="text-right space-y-1">
                                @for (hours of getOpeningHoursForDay(day.label); track hours) {
                                    <div class="text-app-secondary-10">{{hours.from | date: 'HH:mm'}} - {{hours.to | date: 'HH:mm'}} Uhr</div>
                                } @empty {
                                    <span class="text-gray-400 italic">Geschlossen</span>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>

            <!-- Holidays Card -->
            <div class="bg-white rounded-button shadow-sm border border-app-primary-10 p-6 space-y-4">
                <div class="flex flex-col lg:flex-row items-center justify-between border-b border-gray-50 pb-4 gap-2">
                    <div class="text-xl font-bold text-app-primary-10">Urlaub {{now | date: 'yyyy'}}</div>
                    <button class="btn tertiary-button" routerLink="/administration">Urlaub anpassen</button>
                </div>

                <div class="space-y-6">
                    @for (group of getHolidaysByMonth(); track group.month) {
                        <div class="flex gap-8">
                            <div class="w-24 shrink-0 text-sm font-semibold text-app-primary-10">{{group.month}}</div>
                            <div class="space-y-3 flex-1">
                                @for (holiday of group.items; track holiday) {
                                    <div class="text-sm text-app-secondary-10 flex flex-col">
                                        <span>{{holiday.from | date: 'dd.MM.yyyy'}} -</span>
                                        <span>{{holiday.to | date: 'dd.MM.yyyy'}}</span>
                                    </div>
                                }
                            </div>
                        </div>
                    } @empty {
                        <div class="flex flex-col items-center justify-center py-12 text-center text-gray-400 space-y-2">
                            <i class="fa-solid fa-umbrella-beach text-3xl opacity-20"></i>
                            <p>Kein Urlaub geplant</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
} @else if (isLoading) {
    <div class="flex items-center justify-center h-[60vh]">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary-10"></div>
    </div>
}

